import { useEffect } from "react";
import { PolicyAndSecurity } from "./policyAndSecurity/Index";
import { PolicyHeader } from "./policyAndSecurity/PolicyHeader";
import "./styles.css";

export function PolicyAndSecurityPage() {
  useEffect(() => {
    document.title = "Pastejo | Política e Segurança";
  }, []);

  return (
    <div className="home-page-v2">
      <PolicyHeader />
      <PolicyAndSecurity />
    </div>
  );
}
